import { Navigate, useLocation, useParams } from "react-router-dom";

/** Redirect legacy dashboard query-param routes to new portal paths */
export const PartnerLegacyDashboardRedirect = () => {
  const location = useLocation();
  const tab = new URLSearchParams(location.search).get("tab");
  if (tab === "applications") return <Navigate to="/partners/applications" replace />;
  if (tab === "settings") return <Navigate to="/partners/settings" replace />;
  return <Navigate to="/partners/programs" replace />;
};

export const PartnerLegacyProgramRedirect = () => (
  <Navigate to="/partners/programs/new" replace />
);

/**
 * Old /partners/opportunities* URLs → /partners/programs*
 * Supports list, view, edit, and bare :id links.
 */
export const PartnerLegacyOpportunityRedirect = () => {
  const { id } = useParams();
  const location = useLocation();
  const path = location.pathname;

  if (path.endsWith("/opportunities") || path.endsWith("/opportunities/")) {
    return <Navigate to="/partners/programs" replace />;
  }
  if (path.includes("/opportunities/new")) {
    return <Navigate to="/partners/programs/new" replace />;
  }
  if (path.includes("/opportunities/edit/") && id) {
    return <Navigate to={`/partners/programs/edit/${id}`} replace />;
  }
  if (path.includes("/opportunities/view/") && id) {
    return <Navigate to={`/partners/programs/view/${id}`} replace />;
  }
  if (id && id !== "new") {
    return <Navigate to={`/partners/programs/view/${id}`} replace />;
  }
  return <Navigate to="/partners/programs" replace />;
};
